export default __webpack_public_path__ + "static/media/0x3c720206bfacb2d16fa3ac0ed87d2048dbc401fc.16d845eb.webp";